import { render } from "./CheckmarkIcon.vue?vue&type=template&id=0b548d4e"
import script from "./CheckmarkIcon.vue?vue&type=script&lang=js"
export * from "./CheckmarkIcon.vue?vue&type=script&lang=js"
script.render = render

export default script